import React from "react";
import { Card, CardContent } from "../../ui/card";

export const PainBanner = ({ persona, pain, answer, testid }) => (
  <div className="rounded-md border border-sky-500/30 bg-sky-500/5 px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-1" data-testid={testid}>
    <span className="text-[10px] font-bold tracking-[0.2em] text-sky-300">{persona}</span>
    <span className="text-sm italic text-foreground/90">"{pain}"</span>
    <span className="text-[11px] text-muted-foreground ml-auto">answered at a glance by: {answer}</span>
  </div>
);

export const Headline = ({ children, testid }) => (
  <div className="text-2xl md:text-3xl font-black tracking-tight" data-testid={testid}>{children}</div>
);

export const Kpi = ({ label, value, sub, tone = "", testid }) => (
  <Card data-testid={testid}><CardContent className="py-3">
    <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">{label}</div>
    <div className={`font-mono text-2xl font-bold mt-0.5 ${tone}`}>{value}</div>
    {sub && <div className="text-[11px] text-muted-foreground mt-0.5">{sub}</div>}
  </CardContent></Card>
);

export const Pill = ({ children, tone = "muted" }) => {
  const c = {
    good: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40", alert: "bg-amber-500/15 text-amber-400 border-amber-500/40",
    bad: "bg-red-500/15 text-red-400 border-red-500/40", info: "bg-sky-500/15 text-sky-300 border-sky-500/40",
    muted: "bg-muted text-muted-foreground border-border", violet: "bg-violet-500/15 text-violet-300 border-violet-500/40",
  }[tone];
  return <span className={`px-1.5 py-0.5 rounded border text-[10px] font-mono whitespace-nowrap ${c}`}>{children}</span>;
};

export const SectionTitle = ({ children, right }) => (
  <div className="flex items-center justify-between gap-3 mb-2">
    <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{children}</div>
    {right}
  </div>
);

export const pct = (v, d = 1) => `${v > 0 ? "+" : v < 0 ? "−" : ""}${Math.abs(v).toFixed(d)}%`;
